<template>
  <v-app class="app">
    <LoadingScreen :is-loading="$store.state.loading" />
    <OverlayScroller :switch="overlayTrigger" :html="overlayHtml" />

    <v-dialog
      persistent
      v-model="termsAccept"
      :width="$vuetify.breakpoint.xs ? '100%' : '80%'"
      max-width="400px"
      :class="$vuetify.breakpoint.xs ? 'ma-0' : 'ma-2'"
    >
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            {{ $t('dialog.newterms1') }}
            <a @click="showOverlay('terms')">{{ $t('dialog.newterms2') }}</a>
            {{ $t('dialog.newterms3') }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" class="pa-5">
            <v-btn :to="{ name: 'logout', params: { lang: $i18n.locale } }" block color="grey darken-1" dark>{{
              $t('button.decline')
            }}</v-btn>
          </v-col>
          <v-col cols="6" class="pa-5">
            <v-btn @click="acceptTerms" block color="rgb(0, 115, 181)" dark>{{ $t('button.accept') }}</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="dialogEdit"
      :width="$vuetify.breakpoint.xs ? '100%' : '80%'"
      max-width="900px"
      :class="$vuetify.breakpoint.xs ? 'ma-0' : 'ma-2'"
    >
      <benutzer-formular
        v-if="dialogEdit"
        :benutzer-id="$store.state.userdata.id"
        @editorClose="dialogClose"
        :type="accountNotComplete ? 'verify' : ''"
      />
    </v-dialog>
    <Confirm ref="confirm" />

    <!-- empty overlay to "gray out" the content -->
    <v-overlay :value="!$store.state.cookieSelectionMade" z-index="500" class="d-flex align-center justify-center">
      <v-card v-if="!$store.state.cookieSelectionMade" light class="cookieSettings">
        <v-card-title>
          {{ $t('navigation.privacy') }}
        </v-card-title>
        <v-card-subtitle class="d-flex align-center">
          <v-btn small class="px-0 mr-1" text @click="showOverlay('imprint')">Impressum</v-btn> |
          <v-btn small class="px-0 ml-1" text @click="showOverlay('privacy')">Datenschutz</v-btn>
        </v-card-subtitle>
        <v-card-text>
          {{ $t('label.cookiesText') }}
          <v-sheet class="cookieSettings">
            <v-divider class="mt-4" />
            <v-sheet color="transparent" class="d-flex align-center">
              <v-sheet>
                <strong>Google Analytics</strong>
                <v-btn class="ml-1" fab x-small plain @click="showOverlay('analytics')">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
                <br />
                Google LLC, USA
              </v-sheet>
              <v-spacer /><v-switch v-model="analyticsAccepted" inset />
            </v-sheet>
            <v-divider />
            <v-sheet style="background-color: red" color="transparent">
              <v-sheet class="d-flex align-center">
                <strong>AdWords</strong>
                <v-btn class="ml-1" fab x-small plain @click="showOverlay('adwords')">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </v-sheet>

              <v-sheet class="d-flex align-center mb-3">
                {{ $t('label.adwordsStorage') }}<v-spacer /><v-switch
                  class="mt-0"
                  hide-details
                  v-model="adwordsStorageAccepted"
                  inset
                />
              </v-sheet>
              <v-sheet class="d-flex align-center mb-3">
                {{ $t('label.adwordsSharing') }}<v-spacer /><v-switch
                  class="mt-0"
                  hide-details
                  v-model="adwordsSharingAccepted"
                  inset
                />
              </v-sheet>
              <v-sheet class="d-flex align-center mb-2">
                {{ $t('label.adwordsPersonalization') }}<v-spacer /><v-switch
                  class="mt-0"
                  hide-details
                  v-model="adwordsPersonalizationAccepted"
                  inset
                />
              </v-sheet>

              Google LLC, USA
            </v-sheet>
            <v-divider />
            <v-sheet
              color="transparent"
              class="d-flex align-center"
              :class="{
                highlightRecaptcha: $route.name === 'login'
              }"
            >
              <v-sheet>
                <strong>Google reCAPTCHA {{ $t('label.recaptchaNeeded') }}</strong>
                <v-btn class="ml-1" fab x-small plain @click="showOverlay('recaptcha')">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
                <br />
                Google LLC, USA
              </v-sheet>
              <v-spacer /><v-switch v-model="recaptchaAccepted" inset />
            </v-sheet>
          </v-sheet>

          <v-sheet class="d-flex mt-4">
            <v-btn small @click="rejectAllCookies" class="mr-4">{{ $t('button.decline') }}</v-btn>
            <v-btn small @click="acceptCookieSelection">{{ $t('label.acceptSelected') }}</v-btn>
            <v-spacer />
            <v-btn small class="ml-8" @click="acceptAllCookies">{{ $t('label.accept') }}</v-btn>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-app-bar
      v-if="!isPanel"
      class="myAppBar pr-4"
      height="60"
      color="rgb(0, 115, 181)"
      elevation="0"
      app
      short
      clipped-left
    >
      <div class="whiteLogoParking">
        <a href="https://www.ecoplus.at" target="_blank">
          <v-img width="60" height="60" src="/img/logo_ecoplus.webp" alt="ecoplus Logo" />
        </a>
      </div>
      <div v-if="isAdmin === true" class="claim pa-3">
        <v-icon dark x-large>mdi-cogs</v-icon>
        <v-btn
          v-if="isAdmin === true"
          color="rgba(0, 115, 181)"
          depressed
          dark
          :to="{ name: 'home', params: { lang: $i18n.locale } }"
        >
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </div>
      <div class="noelogo" v-if="isAdmin === false">
        <a href="https://www.noe.gv.at/" target="_blank"
          ><v-img contain height="60" width="66.666666" :transition="false" src="/img/noe-logo.webp" alt="Bildmarke NÖ"
        /></a>
      </div>
      <v-spacer />
      <div class="shownAboveMobile">
        <v-btn
          min-width="30"
          v-if="isAdmin === false"
          color="rgba(0, 115, 181)"
          depressed
          dark
          :to="{ name: 'home', params: { lang: $i18n.locale } }"
          ><v-icon color="white" size="20">mdi-home</v-icon>
        </v-btn>
        <v-btn
          v-if="isAdmin === false"
          color="rgba(0, 115, 181)"
          depressed
          dark
          @click="restoreOriginalExtent()"
          :to="{ name: 'standortsuche', params: { lang: $i18n.locale } }"
        >
          {{ $t('navigation.standortsuche') }}
        </v-btn>
        <v-btn
          v-if="isAdmin === false"
          color="rgba(0, 115, 181)"
          depressed
          dark
          :to="{ name: 'foerderkompass', params: { lang: $i18n.locale } }"
        >
          {{ $t('navigation.advancementcompass') }}
        </v-btn>
        <v-btn
          v-if="isAdmin === false"
          color="rgba(0, 115, 181)"
          depressed
          dark
          :to="{ name: 'wissen', params: { lang: $i18n.locale } }"
        >
          {{ $t('navigation.knowhow') }}
        </v-btn>

        <v-menu
          offset-y
          v-if="!$route.query.barrierefrei && isAdmin === false && $store.state.userdata && $store.state.userdata.id"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="rgba(0, 115, 181)" depressed dark class="mycompass">
              <v-icon small class="mr-2"> mdi-account </v-icon>
              {{ $t('navigation.mycompass') }}
            </v-btn>
          </template>
          <v-list class="backBlue">
            <v-btn @click="dialogEdit = !dialogEdit" color="rgba(0, 115, 181)" depressed dark block>
              <v-icon small class="mr-2"> mdi-account-cog </v-icon>
              {{ $t('navigation.account') }}
            </v-btn>
            <v-btn
              color="rgba(0, 115, 181)"
              depressed
              dark
              block
              :to="{ name: 'meineimmobilien', params: { lang: $i18n.locale } }"
            >
              <v-icon small class="mr-2"> mdi-home-account </v-icon>
              {{ $t('navigation.myproperties') }}
            </v-btn>
            <v-btn
              color="rgba(0, 115, 181)"
              v-if="$store.state.userdata && $store.state.userdata.id"
              depressed
              dark
              block
              @click="showOverlay('contactEcoplus')"
            >
              <v-icon small class="mr-2"> mdi-human-greeting-variant </v-icon>
              {{ $t('navigation.contactEcoplus') }}
            </v-btn>
            <v-btn
              color="rgba(0, 115, 181)"
              depressed
              dark
              block
              :to="{ name: 'browse', params: { lang: $i18n.locale } }"
              v-if="isAdmin === false && $store.state.userdata && $store.state.userdata.userlevel > 4"
            >
              <v-icon small class="mr-2"> mdi-cogs </v-icon>
              {{ $t('menu.administration') }}
            </v-btn>

            <v-btn
              :to="{ name: 'logout', params: { lang: $i18n.locale } }"
              color="rgba(0, 115, 181)"
              depressed
              dark
              block
            >
              <v-icon small class="mr-2"> mdi-logout </v-icon>
              {{ $t('button.logout') }}
            </v-btn>
          </v-list>
        </v-menu>

        <v-btn
          v-if="!$route.query.barrierefrei && isAdmin === false && $store.state.userdata && $store.state.userdata.id"
          :disabled="$route.name === 'edit-objekt'"
          color="rgba(0, 115, 181)"
          depressed
          dark
          @click="createNewProperty"
          class="newImmo"
        >
          {{ $t('navigation.titlenewproperty') }}
        </v-btn>

        <v-btn
          :to="{ name: 'login', params: { lang: $i18n.locale } }"
          v-if="
            !$route.query.barrierefrei && isAdmin === false && (!$store.state.userdata || !$store.state.userdata.id)
          "
          color="rgba(0, 115, 181)"
          depressed
          dark
          class="mycompass"
        >
          <v-icon small class="mr-2"> mdi-account </v-icon>
          {{ $t('button.login') }}
        </v-btn>
      </div>
      <v-select
        v-if="isAdmin === false"
        dark
        dense
        hide-details
        :items="langkeys"
        v-model="currentLanguage"
        class="langSelect"
      />
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        @click="restoreOriginalExtent()"
        :to="{ name: 'browse', params: { lang: $i18n.locale } }"
      >
        Objektverwaltung
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-foerdermatrix', params: { lang: $i18n.locale } }"
      >
        Fördermatrix
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-benutzer', params: { lang: $i18n.locale } }"
      >
        Benutzerverwaltung
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-karten', params: { lang: $i18n.locale } }"
      >
        Kartenverwaltung
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-kampagnen', params: { lang: $i18n.locale } }"
      >
        Kampagnen
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-glossar', params: { lang: $i18n.locale } }"
      >
        Glossar
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-statistik', params: { lang: $i18n.locale } }"
      >
        Statistik
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0, 115, 181)"
        depressed
        dark
        :to="{ name: 'admin-urlmanagement', params: { lang: $i18n.locale } }"
      >
        URL Management
      </v-btn>
      <v-btn
        v-if="isAdmin === true"
        color="rgba(0,90,154)"
        depressed
        dark
        :to="{ name: 'logout', params: { lang: $i18n.locale } }"
      >
        <v-icon>mdi-power</v-icon>
      </v-btn>

      <v-app-bar-nav-icon dark class="hiddenAboveMobile" aria-label="Navigation" @click.stop="drawer = !drawer" />
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      class="navigationDrawer hiddenAboveMobile"
      absolute
      right
      clipped
      width="280px"
      height="auto"
      color="rgb(0, 115, 181)"
    >
      <v-btn
        v-if="isAdmin === false"
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mt-15 mobile"
        :to="{ name: 'home', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.home') }}
      </v-btn>
      <v-btn
        v-if="isAdmin === false"
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mobile"
        @click="restoreOriginalExtent()"
        :to="{ name: 'standortsuche', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.standortsuche') }}
      </v-btn>
      <v-btn
        v-if="isAdmin === false"
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mobile"
        :to="{ name: 'foerderkompass', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.advancementcompass') }}
      </v-btn>
      <v-btn
        v-if="isAdmin === false"
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mobile"
        :to="{ name: 'wissen', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.knowhow') }}
      </v-btn>

      <div
        class="myAccountMobile"
        :class="{
          opened: isAdmin === false && $store.state.userdata && $store.state.userdata.id
        }"
      >
        <v-btn @click="dialogEdit = !dialogEdit" color="rgba(0, 115, 181)" depressed dark block class="mobile">
          <v-icon small class="mr-2"> mdi-account-cog </v-icon>
          {{ $t('navigation.account') }}
        </v-btn>
        <v-btn
          color="rgba(0, 115, 181)"
          depressed
          dark
          block
          class="mobile"
          :to="{ name: 'meineimmobilien', params: { lang: $i18n.locale } }"
        >
          <v-icon small class="mr-2"> mdi-home-account </v-icon>
          {{ $t('navigation.myproperties') }}
        </v-btn>
        <v-btn
          color="rgba(0, 115, 181)"
          v-if="$store.state.userdata && $store.state.userdata.id"
          depressed
          dark
          block
          class="mobile"
          @click="showOverlay('contactEcoplus')"
        >
          <v-icon small class="mr-2"> mdi-human-greeting-variant </v-icon>
          {{ $t('navigation.contactEcoplus') }}
        </v-btn>
        <v-btn
          color="rgba(0, 115, 181)"
          depressed
          dark
          block
          class="mobile"
          :to="{ name: 'browse', params: { lang: $i18n.locale } }"
          v-if="isAdmin === false && $store.state.userdata && $store.state.userdata.userlevel > 4"
        >
          <v-icon small class="mr-2"> mdi-cogs </v-icon>
          {{ $t('menu.administration') }}
        </v-btn>

        <v-btn
          :to="{ name: 'logout', params: { lang: $i18n.locale } }"
          color="rgba(0, 115, 181)"
          depressed
          dark
          block
          class="mobile"
        >
          <v-icon small class="mr-2"> mdi-logout </v-icon>
          {{ $t('button.logout') }}
        </v-btn>
      </div>

      <v-btn
        :to="{ name: 'login', params: { lang: $i18n.locale } }"
        v-if="isAdmin === false && (!$store.state.userdata || !$store.state.userdata.id)"
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mycompass mobile"
      >
        <v-icon small class="mr-2"> mdi-account </v-icon>
        {{ $t('button.login') }}
      </v-btn>

      <!-- FIXME empty div? -->
      <div class="myAccountMobile" v-if="!$vuetify.breakpoint.smAndUp"></div>
      <!-- FIXME smAndUp or no v-if at all -->
      <v-btn
        v-if="!$vuetify.breakpoint.xsAndUp"
        small
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mobile"
        :to="{ name: 'nutzungsbedingungen', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.terms') }}
      </v-btn>
      <v-btn
        v-if="!$vuetify.breakpoint.xsAndUp"
        small
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mobile"
        :to="{ name: 'datenschutz', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.privacy') }}
      </v-btn>

      <v-btn
        v-if="!$vuetify.breakpoint.xsAndUp"
        small
        color="rgba(0, 115, 181)"
        depressed
        dark
        block
        class="mobile"
        :to="{ name: 'glossar', params: { lang: $i18n.locale } }"
      >
        {{ $t('navigation.glossary') }}
      </v-btn>
    </v-navigation-drawer>

    <v-main class="mainPage" :class="{ admin: isAdmin }">
      <router-view />
    </v-main>
    <v-footer v-if="!isPanel && isAdmin === false" color="rgb(0, 115, 181)" elevation="0" dark padless>
      <v-row no-gutters>
        <v-col class="pl-1" :cols="$vuetify.breakpoint.smAndUp ? 9 : 6">
          <v-btn
            small
            color="rgba(0, 115, 181)"
            depressed
            dark
            :to="{ name: 'kontakt', params: { lang: $i18n.locale } }"
          >
            {{ $t('navigation.contact') }} /
            {{ $t('navigation.imprint') }}
          </v-btn>
          <v-btn
            v-if="!$vuetify.breakpoint.smAndDown"
            small
            color="rgba(0, 115, 181)"
            depressed
            dark
            :to="{ name: 'nutzungsbedingungen', params: { lang: $i18n.locale } }"
          >
            {{ $t('navigation.terms') }}
          </v-btn>
          <v-btn
            v-if="!$vuetify.breakpoint.smAndDown"
            small
            color="rgba(0, 115, 181)"
            depressed
            dark
            :to="{ name: 'datenschutz', params: { lang: $i18n.locale } }"
          >
            {{ $t('navigation.privacy') }}
          </v-btn>
          <v-btn
            v-if="!$vuetify.breakpoint.smAndDown"
            small
            color="rgba(0, 115, 181)"
            depressed
            dark
            :to="{ name: 'glossar', params: { lang: $i18n.locale } }"
          >
            {{ $t('navigation.glossary') }}
          </v-btn>
        </v-col>
        <v-col class="pr-1" align="right" :cols="$vuetify.breakpoint.smAndUp ? 3 : 6">
          <v-btn small color="rgba(0, 115, 181)" depressed dark @click="switchBarrierefrei()">
            {{ $route.query.barrierefrei ? $t('navigation.leaveBarrierfree') : $t('navigation.barrierfree') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Confirm from '@/components/misc/Confirm.vue';
import OverlayScroller from '@/components/misc/OverlayScroller.vue';
import LoadingScreen from './components/misc/Loading.vue';
import { bind as bindObjektSource } from '@/main/objektSource';
import { decodeUriValueForKey, defaultFilterValues } from '@/store/defaultValues';
import benutzerFormular from '@/components/forms/benutzerform.vue';
import { getCookie } from './utils/utils';
import axios from 'redaxios';
import { noeExtent } from './main/constants';
import { objektCreator } from '@/mixins/objektCreator';

export default {
  name: 'App',
  components: {
    LoadingScreen,
    Confirm,
    benutzerFormular,
    OverlayScroller
  },
  mixins: [objektCreator],
  data: () => ({
    overlayTrigger: false,
    overlayHtml: '',
    dialogEdit: false,
    drawer: false,
    loadingElements: {},
    headerItems: null,
    langkeys: [
      { text: 'DE', value: 'de' },
      { text: 'EN', value: 'en' }
    ],
    analyticsAccepted: null,
    adwordsStorageAccepted: null,
    adwordsSharingAccepted: null,
    adwordsPersonalizationAccepted: null,
    recaptchaAccepted: null
  }),
  computed: {
    currentLanguage: {
      get() {
        return this.$i18n.locale;
      },
      set(value) {
        this.$i18n.locale = value;
        this.$router.push({ params: { ...this.$route.params, lang: value }, query: this.$route.query });
      }
    },
    termsAccept() {
      return this.$store.state.userdata &&
        this.$store.state.userdata.data &&
        this.$store.state.userdata.termsaccepted === false
        ? true
        : false;
    },
    isPanel() {
      return this.$route.path.indexOf('panel') > -1;
    },

    isAdmin() {
      return !!this.$route.meta.requiresAuth;
    },

    accountNotComplete() {
      return this.$store.state.userdata?.email && this.$store.state.userdata.profil !== 100;
    },
    /**
     * current query params from the store, consisting of zoom/center and filters
     * the only function of this computed prop is to have a single watcher for all filter values
     */
    queryParamsFromStore() {
      const state = this.$store.state;
      return {
        selectedType: state.selectedType,
        selectedFlaeche: state.selectedFlaeche,
        selectedPreis: state.selectedPreis,
        mieteOrKauf: state.mieteOrKauf,
        selectedTag: state.selectedTag,
        favsOnly: state.favsOnly,
        onlyProperties: state.onlyProperties,
        selectedStatus: state.selectedStatus
      };
    }
  },

  watch: {
    '$store.state.contact'(value) {
      if (value) {
        const contactShown = getCookie('contactShown');
        if (contactShown !== 'true') {
          this.showOverlay('contactEcoplus');
        }
      }
    },
    accountNotComplete(value) {
      if (value) {
        this.dialogEdit = true;
      }
    },
    '$route.query'() {
      // update the store when the route changes
      // handles back button
      const query = this.$route.query;
      if (this.$route.query.activated && this.$route.query.activated == '1') {
        this.$root.$confirm({
          title: `${this.$t('label.activatedHeader')}`,
          message: `${this.$t('label.activatedText')}`,
          okonly: true,
          appearance: 'success'
        });
      }

      for (const key in defaultFilterValues) {
        // eslint-disable-next-line no-prototype-builtins
        if (query.hasOwnProperty(key)) {
          const value = query[key];
          const decodedValue = decodeUriValueForKey(key, value);
          this.$store.dispatch(key, decodedValue);
        } else if (this.$store.state[key] !== defaultFilterValues[key]) {
          this.$store.dispatch(key, defaultFilterValues[key]);
        }
      }
    },
    queryParamsFromStore(value) {
      const router = this.$router;
      const currentRoute = this.$route;
      const currentQuery = currentRoute.query;
      const newQuery = Object.assign({}, currentQuery);
      for (const key in value) {
        // if the current value in the store is equal to the default value, remove it from the url
        if (value[key]?.toString() === defaultFilterValues[key]?.toString()) {
          // https://forum.vuejs.org/t/how-to-remove-one-query-string-from-url/39176/2
          newQuery[key] = undefined;
        } else {
          // else, if the value in the store is not equal to the value in the url query, update the query
          newQuery[key] = encodeURIComponent(value[key]);
        }
      }
      if (JSON.stringify(newQuery) !== JSON.stringify(currentQuery)) {
        router
          .push({
            query: newQuery
          })
          .catch(() => {});
      }
    },
    group() {
      this.drawer = false;
    }
  },
  created() {
    try {
      const acceptedCookies = JSON.parse(localStorage.getItem('acceptedCookies'));
      if (acceptedCookies) {
        this.analyticsAccepted = acceptedCookies.analyticsAccepted;
        this.adwordsStorageAccepted = acceptedCookies.adwordsStorageAccepted;
        this.adwordsSharingAccepted = acceptedCookies.adwordsSharingAccepted;
        this.adwordsPersonalizationAccepted = acceptedCookies.adwordsPersonalizationAccepted;
        this.recaptchaAccepted = acceptedCookies.recaptchaAccepted;
        this.$store.dispatch('cookieSelectionMade', true);
        this.$store.dispatch('recaptchaAccepted', acceptedCookies.recaptchaAccepted);
        this.setupOrUpdateGTM();
      }
    } catch {
      // no cookies found or wrong format in localstorage
    }
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    bindObjektSource();
    this.$root.$on('loading', data => {
      this.$store.dispatch('loading', true);
      this.loadingElements[data] = true;
    });
    this.$root.$on('loaded', data => {
      delete this.loadingElements[data];
      this.checkLoaded(); // force computed
    });
  },
  mounted() {
    //@ts-ignore
    this.$root.$confirm = this.$refs.confirm.open;
    this.$store.dispatch('fetchUserdata');
  },
  methods: {
    async acceptTerms() {
      try {
        await axios.get('/api/termsaccepted/' + this.$store.state.userdata.data.id);
        this.$store.dispatch('userdata', this.$store.state.userdata.data);
      } catch (err) {
        this.$root.$confirm({
          title: this.$t('error.termsaccepted.title').toString(),
          message: this.$t('error.termsaccepted.text').toString(),
          okonly: true,
          appearance: 'success'
        });
      }
    },
    showOverlay(content) {
      this.overlayHtml = content;
      this.overlayTrigger = !this.overlayTrigger;
    },
    dialogClose() {
      this.dialogEdit = false;
    },
    rejectAllCookies() {
      this.analyticsAccepted = false;
      this.adwordsStorageAccepted = false;
      this.adwordsSharingAccepted = false;
      this.adwordsPersonalizationAccepted = false;
      this.recaptchaAccepted = false;
      this.$store.dispatch('cookieSelectionMade', true);
      this.$store.dispatch('recaptchaAccepted', false);
      this.setupOrUpdateGTM();
    },
    acceptAllCookies() {
      this.analyticsAccepted = true;
      this.adwordsStorageAccepted = true;
      this.adwordsSharingAccepted = true;
      this.adwordsPersonalizationAccepted = true;
      this.recaptchaAccepted = true;
      this.$store.dispatch('cookieSelectionMade', true);
      this.$store.dispatch('recaptchaAccepted', true);
      this.setupOrUpdateGTM();
    },
    acceptCookieSelection() {
      this.$store.dispatch('cookieSelectionMade', true);
      this.$store.dispatch('recaptchaAccepted', this.recaptchaAccepted);
      this.setupOrUpdateGTM();
    },
    switchBarrierefrei() {
      const router = this.$router;
      const currentRoute = this.$route;
      const query = currentRoute.query;
      const newQuery = Object.assign({}, query);
      // https://forum.vuejs.org/t/how-to-remove-one-query-string-from-url/39176/2
      newQuery.barrierefrei = query.barrierefrei ? undefined : 'true';
      router
        .replace({
          query: newQuery
        })
        .catch(() => {});
    },
    checkLoaded() {
      if (Object.keys(this.loadingElements).length === 0) {
        this.$store.dispatch('loading', false);
      }
    },
    restoreOriginalExtent() {
      const view = this.$map.getView();
      if (view.getCenter() === undefined || view.getZoom() === undefined) {
        return;
      }
      this.$map.getView().fit(noeExtent, {
        padding: [30, 30, 30, 30]
      });
    },
    setupOrUpdateGTM() {
      // get the gtag permissions based on the current user input / saved localstorage input
      const ad_storage = this.adwordsStorageAccepted === true ? 'granted' : 'denied';
      const ad_user_data = this.adwordsSharingAccepted === true ? 'granted' : 'denied';
      const ad_personalization = this.adwordsPersonalizationAccepted === true ? 'granted' : 'denied';
      const analytics_storage = this.analyticsAccepted === true ? 'granted' : 'denied';
      const security_storage = this.recaptchaAccepted === true ? 'granted' : 'denied';

      localStorage.setItem(
        'acceptedCookies',
        JSON.stringify({
          analyticsAccepted: !!this.analyticsAccepted,
          adwordsStorageAccepted: !!this.adwordsStorageAccepted,
          adwordsSharingAccepted: !!this.adwordsSharingAccepted,
          adwordsPersonalizationAccepted: !!this.adwordsPersonalizationAccepted,
          recaptchaAccepted: !!this.recaptchaAccepted
        })
      );
      // @ts-ignore
      if (
        !window.gtag &&
        !this.analyticsAccepted &&
        !this.adwordsStorageAccepted &&
        !this.adwordsSharingAccepted &&
        !this.adwordsPersonalizationAccepted &&
        !this.recaptchaAccepted
      ) {
        // don't load gtm at all
        return;
      }

      // @ts-ignore
      if (!window.gtag) {
        // https://developers.google.com/tag-platform/security/guides/consent?hl=de&consentmode=advanced#tag-manager_3
        // Define dataLayer and the gtag function.
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.gtag = function () {
          //@ts-ignore
          window.dataLayer.push(arguments);
        };

        //@ts-ignore
        window.gtag('consent', 'default', {
          analytics_storage,
          ad_storage,
          ad_user_data,
          ad_personalization,
          security_storage
        });

        // actual setup of the google tag manager
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          const f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
          //@ts-ignore
          j.async = true;
          //@ts-ignore
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-5D8R89Q');
      } else {
        //@ts-ignore
        window.gtag('consent', 'update', {
          analytics_storage,
          ad_storage,
          ad_user_data,
          ad_personalization,
          security_storage
        });
      }
    }
  }
};
</script>

<style>
html,
body {
  margin: 0px !important;
  padding: 0px;
  font-size: 14px;
}

.yellowButtonBlueText {
  border: 1px solid rgb(136, 188, 226) !important;
}

.newImmo {
  color: rgb(255, 213, 0) !important;
}

.row-pointer {
  cursor: pointer;
}

.thinBlueBorder {
  border: 1px solid rgba(0, 115, 181);
  border-radius: 0px !important;
}

.shadowy {
  box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.5);
}

.myAppBar .v-toolbar__content {
  padding: 0px !important;
}

.myAppBar.v-app-bar.v-app-bar--fixed {
  z-index: 10;
}

.cookie__floating__content {
  max-height: 400px !important;
}

.langSelect {
  width: 50px !important;
  max-width: 50px !important;
}

.langSelect .v-input__append-inner {
  width: 20px !important;
}

.langSelect.v-input {
  font-size: 0.875rem;
}
/* TINYMCE NOTIFICATION HACK */
.tox-notifications-container {
  display: none !important;
}

.backBlue {
  background-color: rgba(0, 115, 181) !important;
}

.langSelect.theme--dark.v-text-field--solo .v-input__control .v-input__slot {
  background: none;
  background-color: rgba(0, 115, 181) !important;
  box-shadow: none;
  -webkit-box-shadow: none;
}
.langSelect.theme--dark.v-text-field .v-input__control .v-input__slot::before {
  border: none !important;
}
.langSelect.theme--dark.v-text-field .v-input__control .v-input__slot::after {
  border: none !important;
}

.mce-content-body {
  border: 1px dotted #aaa;
  padding: 5px;
}

.responsiveX {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.responsiveX.topMed {
  margin-top: 30px;
}
.responsiveX.topMed span {
  display: inline;
}
.responsiveX.topMed a {
  display: inline;
}

.responsiveX.topLarge {
  margin-top: 45px;
}

@media only screen and (max-width: 1500px) {
  .responsiveX {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  .responsiveX.topMed {
    margin-top: 25px;
  }
  .responsiveX.topLarge {
    margin-top: 40px;
  }
}
@media only screen and (max-width: 1300px) {
  .responsiveX {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
  .responsiveX.topMed {
    margin-top: 20px;
  }
  .responsiveX.topLarge {
    margin-top: 35px;
  }
}
@media only screen and (max-width: 1000px) {
  .responsiveX {
    width: calc(100% - 10px);
    margin-left: auto;
    margin-right: auto;
  }
  .responsiveX.topMed {
    margin-top: 5px;
  }
  .responsiveX.topLarge {
    margin-top: 15px;
  }
}

.responsiveHeight {
  height: 400px;
  min-height: 400px !important;
  max-height: 400px !important;
}
.responsiveHeight.withControls {
  height: 440px;
  min-height: 440px !important;
  max-height: 440px !important;
}
.responsiveHeight.max250 {
  height: 250px;
  min-height: 250px !important;
  max-height: 250px !important;
}

@media screen and (max-width: 1000px), screen and (max-height: 700px) {
  .responsiveHeight {
    height: 250px;
    min-height: 250px !important;
    max-height: 250px !important;
  }
  .responsiveHeight.withControls {
    height: 290px;
    min-height: 290px !important;
    max-height: 290px !important;
  }
}

.scrollerPage {
  height: calc((var(--vh, 1vh) * 100) - 88px);
  overflow: auto;
}
.scrollerPage.topReduced {
  height: calc((var(--vh, 1vh) * 100) - 118px);
  margin-top: 30px;
}
.ol-zoom.ol-unselectable.ol-control {
  left: auto;
  top: auto;
  right: 10px;
  top: 10px;
}
</style>
<style scoped>
.noelogo {
  background-color: white;
  position: relative;
  width: 90px;
  height: 60px;
}
.noelogo a {
  display: block;
  position: absolute;
  top: 0px;
  left: 12px;
}

.whiteLogoParking {
  cursor: pointer;
  width: 60px;
  height: 60px;
  padding-left: 0px;
  padding-right: 0px;
  text-align: right;
}

.v-btn--active {
  border-radius: 0px;
  border-bottom: 1px solid rgb(255, 213, 0) !important;
}

.v-btn--active.mobile {
  border-bottom: none !important;
  color: rgb(255, 213, 0) !important;
}
.v-btn.mobile {
  height: 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.theme--dark.v-btn--active:hover::before,
.theme--dark.v-btn--active::before {
  opacity: 0;
}
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0px;
  margin-right: 25px;
}
.mycompass {
  padding: 4px !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
}
.mycompass.mobile {
  padding: 0px;
  border: none !important;
}

.claim {
  height: 60px;
  padding-left: 10px;
  padding-top: 15px;
}
.claim div {
  color: #fff;
  font-size: 13px;
  line-height: 14px;
}

.v-main.mainPage {
  min-height: calc(var(--vh, 1vh) * 100 - 28px) !important;
  max-height: calc(var(--vh, 1vh) * 100 - 28px) !important;
}

.v-main.mainPage.admin {
  min-height: calc(var(--vh, 1vh) * 100) !important;
  max-height: calc(var(--vh, 1vh) * 100) !important;
}

.mainPage {
  background-color: white;
}
.mainPageFormer {
  background-color: white;
}

.myAccountMobile {
  border-top: 1px solid white;
  height: 0px;
  overflow: hidden;
}
.myAccountMobile.opened {
  height: auto;
  overflow: visible;
}

.navigationDrawer {
  z-index: 6 !important;
}

.shownAboveMobile {
  display: flex;
}
.hiddenAboveMobile {
  display: none;
}

.cookieSettings {
  max-width: 600px;
  max-height: 70vh;
  overflow-y: auto;
}

.highlightRecaptcha {
  border: 1px solid rgba(255, 0, 0) !important;
}

@media only screen and (max-width: 1140px) {
  .shownAboveMobile {
    display: none;
  }
  .hiddenAboveMobile {
    display: flex;
  }
}
</style>
